import { render, staticRenderFns } from "./YLZAddDevice.vue?vue&type=template&id=2d204a6f"
import script from "./YLZAddDevice.vue?vue&type=script&lang=js"
export * from "./YLZAddDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports